import {configureStore} from '@reduxjs/toolkit';
import {setinitState} from './reducer';


const store = configureStore({
    reducer:{
        setinitState,
    }
});

export default store;